import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";
import { resolveImageUrl } from "../components/ImageUpload";
import SEO from "../components/SEO";
import ShareButtons from "../components/ShareButtons";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(false));
  }, [slug]);

  if (post === null) return <div className="py-32 text-center text-zinc-500">Loading...</div>;
  if (post === false) return <div className="py-32 text-center text-zinc-500">Post not found.</div>;

  const image = post.og_image_url || post.cover_image_url;

  return (
    <>
      <SEO
        title={post.title}
        description={post.meta_description || post.excerpt}
        image={image ? resolveImageUrl(image) : undefined}
        type="article"
      />
      <article className="max-w-3xl mx-auto px-5 sm:px-6 py-12 sm:py-16" data-testid="blog-post-page">
        <Link to="/blog" className="flex items-center gap-1 text-sm text-zinc-500 hover:text-zinc-900 mb-6 sm:mb-8">
          <ArrowLeft size={14} /> All posts
        </Link>
        <div className="overline text-[#F74B64] mb-3">{post.category}</div>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight break-words">{post.title}</h1>
        <div className="flex items-center justify-between flex-wrap gap-4 mt-4">
          <div className="text-sm text-zinc-500">
            By {post.author} · {new Date(post.created_at).toLocaleDateString()}
          </div>
          <ShareButtons title={post.title} testid="blog-share" />
        </div>
        {post.cover_image_url && (
          <img src={resolveImageUrl(post.cover_image_url)} alt={post.title} className="w-full h-64 sm:h-80 lg:h-[420px] object-cover rounded-2xl mt-6 sm:mt-8" />
        )}
        <div className="prose mt-8 sm:mt-10 text-zinc-800 leading-relaxed whitespace-pre-wrap break-words" data-testid="blog-post-content">
          {post.content}
        </div>
        <div className="mt-10 pt-6 border-t border-zinc-200 flex items-center justify-between flex-wrap gap-3">
          <Link to="/blog" className="text-sm text-zinc-500 hover:text-zinc-900 inline-flex items-center gap-1">
            <ArrowLeft size={12} /> More posts
          </Link>
          <ShareButtons title={post.title} testid="blog-share-bottom" />
        </div>
      </article>
    </>
  );
}
